import { z, type ZodType } from 'zod';
import {
  RequestSchema,
  type CreateRequestInput,
  type PatchRequestInput,
  type Request,
  type RequestDuplicateRequest,
} from '@magimp/shared';
import { request } from '../client.js';

export function createRequest(input: CreateRequestInput): Promise<Request> {
  return request<Request>(
    '/requests',
    {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'content-type': 'application/json' },
    },
    {},
    RequestSchema as unknown as ZodType<Request>,
  );
}

export function patchRequest(id: string, body: PatchRequestInput): Promise<Request> {
  return request<Request>(
    `/requests/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    RequestSchema as unknown as ZodType<Request>,
  );
}

export function deleteRequest(id: string): Promise<void> {
  return request<void>(`/requests/${encodeURIComponent(id)}`, { method: 'DELETE' }, {}, z.void());
}

// WHY (#2119): duplicate an existing China request (any status) into a new
//   DRAFT. The response is the new DRAFT's `Request` wire shape (same as
//   `createRequest`); the caller navigates to it.
export function duplicateRequest(id: string, body: RequestDuplicateRequest): Promise<Request> {
  return request<Request>(
    `/requests/${encodeURIComponent(id)}/duplicate`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    RequestSchema as unknown as ZodType<Request>,
  );
}
